module.exports = "https://static.im-cdn.com/mjc/storefront/Simplar/static/media/fb.8d75e9cc.svg";